// Thin wrapper around GA4 gtag. Safe no-op if gtag isn't ready or consent denied
// (Consent Mode handles gating — denied events are dropped/modelled by GA).
export const track = (event, params = {}) => {
  if (typeof window !== "undefined" && typeof window.gtag === "function") {
    window.gtag("event", event, params);
  }
};
